import { useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { View } from 'foundations-components/components/View';
// @ts-ignore no types for this
import { NPS, CSAT, CES } from 'feedback-schema/constants/surveyTypes';
import { RatingInputs } from 'feedback-public-submission-ui/components/RatingInputs';
import CesQuestion from './CesQuestion';
import RatingQuestion from './RatingQuestion';
import { parse } from '../utils/parse';
import { jsx as _jsx } from "react/jsx-runtime";
const MarkerKeys = {
  [NPS]: 'NPS_RATING_QUESTION_LOADED',
  [CES]: 'CES_RATING_QUESTION_LOADED',
  [CSAT]: 'CSAT_RATING_QUESTION_LOADED'
};
const SurveyTypeToComponents = {
  [CES]: CesQuestion,
  [NPS]: RatingQuestion,
  [CSAT]: RatingQuestion
};
const FeedbackQuestion = ({
  device,
  rating,
  setRating,
  surveyType,
  surveyConfig,
  contactProperties
}) => {
  const {
    strings: {
      cesStrings,
      npsStrings
    }
  } = surveyConfig;
  const {
    navTitle,
    Component
  } = useMemo(() => ({
    navTitle: MarkerKeys[surveyType],
    Component: SurveyTypeToComponents[surveyType]
  }), [surveyType]);
  const propsForRating = useMemo(() => {
    switch (surveyType) {
      case CES:
        return {
          cesStrings
        };
      case CSAT:
        return {
          contactProperties,
          question: surveyConfig.ratingQuestion
        };
      case NPS:
        return {
          contactProperties,
          question: npsStrings.question
        };
      default:
        return {};
    }
  }, [surveyType]); // eslint-disable-line

  return /*#__PURE__*/_jsx(NavMarker, {
    name: navTitle,
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, propsForRating, {
      children: /*#__PURE__*/_jsx(View, {
        display: "inline-block",
        marginBlockStart: "500",
        marginBlockEnd: "1000",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(RatingInputs, {
          surveyConfig: surveyConfig,
          surveyType: surveyType,
          device: device,
          rating: parse(rating),
          setRating: setRating
        })
      })
    }))
  });
};
export default FeedbackQuestion;